import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, Trash } from '@phosphor-icons/react';

import {
  AddElementTemplateToJobButton,
  RemoveElementTemplatesButton,
  UpsertElementTemplateButton,
} from 'elements/components';
import { IElementTemplate } from 'elements/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps {
  data: IElementTemplate;
}

export const ActionsCell = ({ data }: IProps) => {
  if (!data) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} sx={{ alignItems: 'center', gap: 1 }}>
      <AddElementTemplateToJobButton elementTemplate={data} />
      <UpsertElementTemplateButton
        elementTemplate={data}
        buttonElement={
          <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <PencilSimpleLine />
          </Typography>
        }
      />
      <RemoveElementTemplatesButton
        elementTemplates={[data]}
        buttonElement={
          <Typography color={Color.DANGER} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <Trash />
          </Typography>
        }
      />
    </Stack>
  );
};
